<template>
  <w-sliding-popup ref="slidingPopup" title="필터 그룹 설정" width="600px" @close="close">
    <div slot="content">
      <el-form ref="form" :model="filterGroupInfo" label-position="top" :rules="filterGroupRules">
        <el-row>
          <el-form-item label="필터 그룹명" prop="filterGroupName">
            <el-input v-model="filterGroupInfo.filterGroupName"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button type="solid" size="large" @click="onSaveButton">저장</el-button>
      <el-button type="content" size="large" @click="clickClose">취소</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import { isEmpty, isNil, cloneDeep } from 'lodash';

import LogAPI from '@/api/log/integrated-log';
import msgUtils from '@/utils/message';

export default {
  name: 'WFilterGroupSettingPopup',
  props: {
    orderbyIndex: Number,
  },
  data() {
    const filterGroupNameRule = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('필수 정보입니다.'));
      }
      if (value.length > 255) {
        return callback(new Error('255자 이내로 입력해주세요.'));
      }
      return callback();
    };
    const filterGroupRules = {
      filterGroupName: [
        { required: true, validator: filterGroupNameRule, trigger: 'blur' },
      ],
    };
    return {
      filterGroupInfo: {
        filterGroupName: '',
        orderbyIndex: this.orderbyIndex,
      },
      filterGroupRules,
    };
  },
  methods: {
    onSaveButton() {
      this.$refs.form.validate().then((success) => {
        if (success) {
          if (isNil(this.filterGroupInfo.filterGroupId)) {
            // 그룹 추가
            this.filterGroupInfo.orderbyIndex = this.orderbyIndex;
            LogAPI.insertFilterGroup(this.filterGroupInfo).then((response) => {
              if (response.data.success) {
                this.$message(msgUtils.getResultMsgData(msgUtils.action.ADD, '필터 그룹', response.data.success));
                this.$refs.slidingPopup.close();
                this.$emit('reload-filter-group');
              } else {
                this.$message(msgUtils.getResultMsgData(msgUtils.action.ADD, '필터 그룹', response.data.success));
              }
            }).catch((e) => {
              this.$message(msgUtils.getResultMsgData(msgUtils.action.ADD, '필터 그룹', false));
              throw new Error(e);
            });
          } else {
            // 그룹 수정
            LogAPI.updateFilterGroup(this.filterGroupInfo).then((response) => {
              if (response.data.success) {
                this.$message(msgUtils.getResultMsgData(msgUtils.action.MODIFY, '필터 그룹', response.data.success));
                this.$refs.slidingPopup.close();
                this.$emit('reload-filter-group');
              } else {
                this.$message(msgUtils.getResultMsgData(msgUtils.action.MODIFY, '필터 그룹', response.data.success));
              }
            }).catch((e) => {
              this.$message(msgUtils.getResultMsgData(msgUtils.action.MODIFY, '필터 그룹', false));
              throw new Error(e);
            });
          }
        }
      });
    },
    clickClose() {
      this.$refs.slidingPopup.close();
    },
    open(filterGroupInfo) {
      if (!isEmpty(filterGroupInfo)) {
        this.filterGroupInfo = cloneDeep(filterGroupInfo);
      }
      this.$refs.slidingPopup.open();
    },
    close() {
      const clear = ['filterGroupName'];
      this.$refs.form.clearValidate(clear);
      this.filterGroupInfo = {
        filterGroupName: '',
      };
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/log-analysis/popup/FilterGroupSettingPopup.vue